import React, {useState} from "react"
import "./NewLogin.scss";
import {useHistory} from "react-router-dom";

import headerLogo from "../../assets/img/header_logo.svg";
import mainLogo from "../../assets/img/main_logo.png";
import billboard from "../../assets/img/billboard.png";
import mobileIcon from "../../assets/img/mobile_icon.svg";

import { Spin, Switch, Alert } from 'antd';

import "antd/dist/antd.css"
import {getUserMerchantsApi, loginApi, loginVerificationApi} from "../../utils/api";
import reh from "../../utils/requestErrorHandling";
import {toast} from "react-toastify";
import * as auth from "../../utils/auth";
import * as mqtt from "../../utils/mqtt";

function NewLogin() {

    const history = useHistory()

    const [loading,set_loading] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState("");
    const [code, set_code] = useState("");
    const [mode, set_mode] = useState("login"); //login | verify
    const [token, set_token] = useState("");


    const login = ()=>{
        set_loading(true)

            loginApi(phoneNumber).then(token => {
                set_loading(false)
                set_mode("verify")
                set_token(token)
            }).catch(err => {
                set_loading(false)
                reh(err, {
                    404: () => {
                        toast.error('کاربری با این شماره وجود ندارد')
                    },
                    403: () => {
                        toast.error('دسترسی برای کاربر وجود ندارد')
                    }
                })
            })
    }


    const verify = ()=>{
        set_loading(true)

        loginVerificationApi(token, code)
            .then(user => {
                auth.login(user);
                mqtt.connect(`merchant_admin_${user.id}`);
                return getUserMerchantsApi();
            })
            .then(merchants => {
                console.log(localStorage.getItem("merchant"))
                localStorage.setItem("acceptor", merchants[0].acceptor);
                localStorage.setItem("merchant_obj", JSON.stringify(merchants[0]));
                localStorage.setItem("merchant", merchants[0].id);
                localStorage.setItem("merchant_name", merchants[0].name);
                localStorage.setItem("merchant_payment_sdk_client_id", merchants[0].payment_sdk_client_id);
                localStorage.setItem("merchant_wallet_id", merchants[0].wallet_id);
                localStorage.setItem("mallwwwwwwwwwww", "wwwwwwwwwww");
                console.log(localStorage.getItem("merchant"))
                setTimeout(function(){ history.replace("/");
                    window.location.reload(false); }, 100);
            })
            .catch(err => {
                reh(err, {});
            })
            .then(() => {
                history.replace("/");
            });

    }


    return(
        <div className="new-login-container">
            <div className="new-login-header">
                <div className="new-login-menu">
                    <span>Support</span>
                    <span>Learn</span>
                    <span>Comunity</span>
                </div>
                <div className="new-login-header-logo">
                    <img src={headerLogo} alt=""/>
                </div>
            </div>
            <div className="new-login-body">
                <div className="new-login-frame-offset"></div>
                <div className="new-login-frame">

                    <Spin spinning={loading}  wrapperClassName="new-login-body-form">
                        {mode==="login"?                        <div className="new-login-spin-form">

                            {/*logo*/}
                            <div className="main-logo">
                                <img src={mainLogo} alt=""/>
                            </div>

                            {/*mode*/}
                            <div className="mode">
                                <span>Login</span>
                            </div>

                            {/*input*/}
                            <div className="new-login-input">

                                <div className="input-sec">
                                    <img src={mobileIcon} alt=""/>
                                    <input type="text" name="" id="" placeholder="09XX XXXXXXX"
                                           value={phoneNumber}
                                           onChange={e=>setPhoneNumber(e.target.value)}
                                    />
                                </div>

                                <div className="message-sec">
                                    <span>mobile number</span>
                                </div>

                            </div>

                            <div className="submit-btn" onClick={login}>
                                <span>Login</span>
                            </div>

                        </div>
                        :null}

                        {mode==="verify"?<div className="new-login-spin-form">

                                {/*logo*/}
                                <div className="main-logo">
                                    <img src={mainLogo} alt=""/>
                                </div>

                                {/*mode*/}
                                <div className="mode">
                                    <span>Verify</span>
                                </div>

                                {/*input*/}
                                <div className="new-login-input">

                                    <div className="input-sec">
                                        <img src={mobileIcon} alt=""/>
                                        <input type="text" name="" id="" placeholder="XXXXX"
                                               value={code}
                                               onChange={e=>set_code(e.target.value)}
                                        />
                                    </div>

                                    <div className="message-sec">
                                        <span>verify code</span>
                                    </div>

                                </div>

                                <div className="submit-btn" onClick={verify}>
                                    <span>Login</span>
                                </div>

                            </div>
                            :null}
                    </Spin>

                    <div className="new-login-body-billboard">
                        <img src={billboard} alt=""/>
                    </div>
                </div>
                <div className="new-login-frame-offset"></div>
            </div>
        </div>
    )
}

export default NewLogin
